import styled from 'styled-components';

export const Heading = styled.div`
  margin-top: 15px;
  ${({ theme }) => theme.fonts.semibold.normal}
`;
